import type { site as en } from '../en/site';

// The public pages in Hindi (D146): warm, everyday Hindi as families speak
// it. "Twinden", "Paperdrop Corp", names, emails and amounts stay as they are.
export const site: Record<keyof typeof en, string> = {
  'site.nav.signIn': 'साइन इन करें',
  'site.nav.openTwinden': 'Twinden खोलें',
  'site.nav.help': 'मदद',
  'site.nav.about': 'हमारे बारे में',
  'site.nav.pricing': 'क़ीमत',
  'site.nav.privacy': 'प्राइवेसी',
  'site.nav.terms': 'शर्तें',
  'site.nav.contact': 'संपर्क',
  'site.chipIn': 'योगदान दें',
  // The native apps' store badges (D344–D345)
  'site.stores.label': 'Twinden ऐप पाएँ',
  'site.stores.appStoreAlt': 'App Store से Twinden डाउनलोड करें',
  'site.stores.playStoreAlt': 'Google Play पर Twinden पाएँ',
  'site.stores.apk': 'Android के लिए डाउनलोड करें (APK)',
  'site.stores.apkHint':
    'फ़ोन पूछेगा कि क्या ब्राउज़र ऐप इंस्टॉल कर सकता है: इस डाउनलोड के लिए अनुमति दें, फिर फ़ाइल खोलकर Twinden इंस्टॉल करें।',
  'site.stores.worksBest': 'Twinden फ़ोन पर ऐप के रूप में सबसे अच्छा चलता है।',
  'site.stores.legalApple':
    'Apple, Apple लोगो और App Store, Apple Inc. के ट्रेडमार्क हैं, जो अमेरिका और अन्य देशों में पंजीकृत हैं।',
  'site.stores.legalGoogle':
    'Google Play और Google Play लोगो, Google LLC के ट्रेडमार्क हैं।',
  'site.footer.anotherProject': '{company} का एक और प्रोजेक्ट',
  // Contact Twinden (M58, D209)
  'site.footer.email': 'हमें लिखें: {email}',
  'site.madeInIndia.title': 'मेड इन इंडिया।',
  'site.madeInIndia.body':
    'पुणे में {company} ने बनाया, दुनिया भर के परिवारों के लिए।',
  'site.madeInIndia.footer': 'पुणे, भारत में वड़ा पाव और कॉफ़ी के दम पर बना',
  'site.flag.india': 'भारत',
  'site.link.privacyPolicy': 'प्राइवेसी पॉलिसी',
  'site.link.encryptionStrength': 'मदद में पढ़ें',
  'site.policy.englishOnly': 'यह पेज अभी अंग्रेज़ी में है।',

  'site.landing.hero.title': 'आपके परिवार का अपना, प्राइवेट घर।',
  'site.landing.hero.body':
    'चैट करें, कॉल करें, और परिवार की लिस्ट, डॉक्यूमेंट और लिंक एक ही जगह रखें। एंड-टू-एंड एन्क्रिप्टेड, न विज्ञापन, न ट्रैकिंग, न पासवर्ड। हर परिवार के लिए मुफ़्त।',
  'site.landing.hero.inviteOnly':
    'Twinden में सिर्फ़ न्योते से आते हैं: परिवार का कोई सदस्य आपको जोड़ता है, या {link}।',
  'site.landing.hero.inviteLink': 'न्योता माँगें',

  'site.landing.preview.group': 'सब लोग',
  'site.landing.preview.members': '{count} लोग',
  'site.landing.preview.nani': 'संडे को कौन आ रहा है? बिरयानी बना रही हूँ 🍲',
  'site.landing.preview.mine': 'हम आ रहे हैं! मीठा हम लाएँगे',
  'site.landing.preview.arjun': 'शॉपिंग लिस्ट में “इलायची” जोड़ दी',
  'site.landing.preview.encrypted': 'एंड-टू-एंड एन्क्रिप्टेड',
  'site.landing.preview.label': 'Twinden में एक परिवार की चैट की झलक',
  'site.landing.preview.family': 'शर्मा परिवार',
  'site.landing.preview.callLine': 'वॉइस कॉल · 12 मिनट',
  'site.landing.preview.callWhen': 'आज, सुबह 9:40',
  'site.landing.preview.listName': 'संडे की शॉपिंग',
  'site.landing.preview.listItem': 'इलायची',
  'site.landing.preview.listDone': 'बासमती चावल',
  'site.landing.preview.placeholder': 'सबसे कुछ कहें',
  'site.landing.preview.navChats': 'चैट',

  'site.landing.why.eyebrow': 'Twinden क्यों',
  'site.landing.why.title': 'उनके लिए, जिन्हें आप परिवार कहते हैं',
  'site.landing.why.intro':
    'ज़्यादातर मैसेजिंग ऐप नेटवर्क बढ़ाने या विज्ञापन बेचने के लिए बने हैं। Twinden सिर्फ़ एक काम के लिए बना है: परिवार को पास रखना, प्राइवेट तरीके से।',
  'site.landing.why.private.title': 'सिर्फ़ आपका परिवार पढ़ सकता है',
  'site.landing.why.private.body':
    'मैसेज, फ़ोटो, वॉइस नोट, फ़ाइलें, लिस्ट और डॉक्यूमेंट भेजे जाने से पहले आपके अपने डिवाइस पर ही लॉक हो जाते हैं। हमारा सर्वर इन्हें रखता है, पर खोल नहीं सकता।',
  'site.landing.why.noAds.title': 'न विज्ञापन, न ट्रैकिंग।',
  'site.landing.why.noAds.body':
    'Twinden में कुछ भी आपका ध्यान या आपका डेटा बेचने के लिए नहीं बना। न विज्ञापन, न एनालिटिक्स ट्रैकर, और कुछ भी बेचा नहीं जाता, कभी नहीं।',
  'site.landing.why.families.title': 'परिवार के लिए, फ़ॉलोअर्स के लिए नहीं',
  'site.landing.why.families.body':
    'हर परिवार की अपनी जगह: सबके साथ एक ग्रुप, और साथ में छोटे ग्रुप और पर्सनल चैट। एक से ज़्यादा परिवारों में हैं? उनके बीच आसानी से बदलें।',
  'site.landing.why.passkeys.title': 'कोई पासवर्ड याद नहीं रखना',
  'site.landing.why.passkeys.body':
    'पासकी के साथ अपने चेहरे, फ़िंगरप्रिंट या स्क्रीन लॉक से साइन इन करें। कोई पासवर्ड ही नहीं, तो न कोई उसका अंदाज़ा लगा सकता है, न धोखे से माँग सकता है, न वो लीक हो सकता है।',
  'site.landing.why.apps.title': 'परिवार का सारा सामान, एक ही जगह',
  'site.landing.why.apps.body':
    'साझा लिस्ट, जिनमें दिखे कि कौन क्या और कब तक करेगा; फ़ोल्डरों में डॉक्यूमेंट; सेव किए लिंक और स्टार किए मैसेज। सब कुछ आपकी चैट की तरह एन्क्रिप्टेड।',
  'site.landing.why.calls.title': 'कमज़ोर सिग्नल पर भी कॉल',
  'site.landing.why.calls.body':
    'छह लोगों तक के लिए वॉइस और वीडियो कॉल, आपके डिवाइसों के बीच एन्क्रिप्टेड। ऑफ़लाइन लिखे मैसेज आपके फ़ोन में रुके रहते हैं और नेटवर्क आते ही चले जाते हैं।',

  'site.landing.see.eyebrow': 'सीधी बात',
  'site.landing.see.title': 'हम क्या देख सकते हैं, और क्या नहीं',
  'site.landing.see.intro':
    'जिस प्राइवेसी को आप जाँच न सकें, वो प्राइवेसी नहीं। इसलिए साफ़-साफ़ बता रहे हैं कि लकीर कहाँ है।',
  'site.landing.see.cantTitle': 'हम नहीं देख सकते',
  'site.landing.see.cantMessages': 'आपके मैसेज में क्या लिखा है',
  'site.landing.see.cantMedia': 'आपकी फ़ोटो, वीडियो और वॉइस नोट',
  'site.landing.see.cantFiles': 'आपकी फ़ाइलें और डॉक्यूमेंट',
  'site.landing.see.cantApps':
    'आपकी लिस्ट में क्या है, और आप कौन-से लिंक सेव करते हैं',
  'site.landing.see.cantCalls': 'आपकी कॉल की आवाज़ और वीडियो',
  'site.landing.see.canTitle': 'हम देख सकते हैं',
  'site.landing.see.canMembers': 'कौन किस परिवार और किस चैट में है',
  'site.landing.see.canTimes': 'मैसेज कब भेजे गए, और किसने पढ़े',
  'site.landing.see.canReactions':
    'रिएक्शन और @मेंशन, ताकि सही लोगों तक नोटिफ़िकेशन पहुँचे',
  'site.landing.see.canCalls': 'किसने किसे कॉल किया, और कितनी देर',
  'site.landing.see.note':
    'एन्क्रिप्शन अक्टूबर 2026 से शुरू हुआ; उससे पहले की चैट और लिस्ट जैसी थीं, वैसी ही हैं। पूरी जानकारी {link} में है।',
  'site.landing.see.strength':
    'एन्क्रिप्शन कितना मज़बूत है, और हमने इसे क्यों चुना: {link}।',

  'site.landing.pricing.eyebrow': 'सबके लिए मुफ़्त',
  'site.landing.pricing.title': 'इसका ख़र्च इसे चलाने वाले परिवार उठाते हैं',
  'site.landing.pricing.intro':
    'Twinden मुफ़्त है, बिना किसी लिमिट और बिना किसी प्रीमियम प्लान के। यहाँ देखिए हर महीने इसका कितना ख़र्च आता है, और परिवारों ने उसमें कितना दिया है। अगर यह आपके परिवार के काम आता है, तो जितना मन हो उतना दीजिए। इससे आपके इस्तेमाल में कुछ नहीं बदलता।',

  'site.landing.name.eyebrow': 'नाम',
  'site.landing.name.title': '“Twinden” क्यों?',
  'site.landing.name.body':
    'Twinden एक कमरे और दो डेस्क वाले दफ़्तर में शुरू हुआ। हम उसे अपना “ट्विन डेन” कहते थे: एक छोटी साझा जगह, जहाँ दो लोग साथ-साथ काम करते हैं। परिवारों के लिए भी हम यही चाहते थे: एक आरामदेह कमरा जिसे आप साझा करें, चाहे हर कोई कहीं भी हो।',
  'site.landing.name.more': 'हमारे बारे में और जानें',
  'site.landing.start.eyebrow': 'शुरुआत कैसे करें',
  'site.landing.start.title': 'अपने परिवार को Twinden पर लाइए',
  'site.landing.start.invitedTitle': 'न्योता मिल चुका है?',
  'site.landing.start.invitedBody':
    'परिवार के किसी सदस्य ने आपके लिए जो QR कोड बनाया है, उसे स्कैन करें। पहले से जुड़े हैं, तो साइन इन करें।',
  'site.landing.start.newTitle': 'अपने परिवार की जगह बनानी है?',
  'site.landing.start.newBody':
    'अभी Twinden में सिर्फ़ न्योते से आते हैं। न्योता माँगिए, हम ईमेल से जवाब देंगे।',
  'site.landing.start.everywhereTitle': 'हर जगह चलता है',
  'site.landing.start.everywhereBody':
    'फ़ोन या कंप्यूटर के किसी भी नए ब्राउज़र में। नोटिफ़िकेशन के लिए इसे होम स्क्रीन पर इंस्टॉल करें। iPhone और Android ऐप जल्द आ रहे हैं।',

  'site.landing.start.everywhereBodyApps':
    'अपने iPhone या Android फ़ोन के लिए ऐप लें। कंप्यूटर पर कोई भी नया ब्राउज़र चलेगा।',
  'site.pricing.title': 'क़ीमत',
  'site.pricing.intro':
    '{name} हर परिवार के लिए मुफ़्त है: न कोई लिमिट, न विज्ञापन, न प्रीमियम प्लान। नीचे देखिए हर महीने इसका कितना ख़र्च आता है, सर्वर से लेकर डेवलपर की फ़ीस और ऑफ़िस तक, और परिवारों ने उसमें कितना दिया है। जब मन हो, जितना मन हो, एक बार दीजिए। इससे आपके इस्तेमाल में कुछ नहीं बदलता, और कोई सब्सक्रिप्शन नहीं है।',
  'site.pricing.razorpay': 'योगदान Razorpay के ज़रिए लिए जाते हैं।',

  'site.costs.coveredThrough': '{month} तक का ख़र्च पूरा',
  'site.costs.covered': 'इस महीने का ख़र्च पूरा हो गया',
  'site.costs.progressLabel': 'इस महीने का कितना ख़र्च पूरा हुआ',
  'site.costs.short': 'इस महीने {amount} कम ({percent}% पूरा)',
  'site.costs.soon': 'इस महीने का ख़र्च जल्द ही यहाँ दिखेगा।',
  'site.costs.estimated': 'अनुमानित',
  'site.costs.total': 'इस महीने का ख़र्च',
  'site.costs.coming': 'आने वाला: {label}',
  'site.costs.paidByFamilies': 'परिवारों ने दिए',
  'site.costs.carriedIn': 'पिछले महीने से',
  'site.costs.balance': 'बैलेंस',
  'site.costs.recent': 'हाल के महीने',
  'site.costs.month': 'महीना',
  'site.costs.costs': 'ख़र्च',
  'site.costs.paid': 'मिला',
  'site.costs.leftOver':
    'जो बचता है वो अगले महीने में जुड़ जाता है, और सिर्फ़ Twinden के ख़र्च में ही लगता है।',
  'site.costs.estimatesNote': ' महीने के बिल आने तक ये आँकड़े अनुमान हैं।',
  'site.costs.item.appServer': 'ऐप सर्वर',
  'site.costs.item.appServerDetail':
    'Twinden को चलाता है: ऐप, मैसेज और कॉल की सिग्नलिंग',
  'site.costs.item.database': 'डेटाबेस',
  'site.costs.item.databaseDetail':
    'अकाउंट, चैट और फ़ैमिली ऐप, एन्क्रिप्ट करके रखे हुए',
  'site.costs.item.storage': 'स्टोरेज और ट्रैफ़िक',
  'site.costs.item.storageDetail': 'एन्क्रिप्टेड फ़ोटो, वीडियो और फ़ाइलें',
  'site.costs.item.domain': 'डोमेन',
  'site.costs.item.developerFees': 'डेवलपर फ़ीस',
  'site.costs.item.office': 'ऑफ़िस',

  'site.about.title': 'हमारे बारे में',
  'site.about.intro':
    'Twinden परिवारों के लिए एक प्राइवेट जगह है, जहाँ सब बात कर सकें, कॉल कर सकें, और अपनी लिस्ट, डॉक्यूमेंट और लिंक साथ रख सकें। यह सिर्फ़ एक काम के लिए बना है: परिवार को पास रखना, बिना किसी और के बीच में सुने।',
  'site.about.standFor': 'हमारे उसूल',
  'site.about.private.title': 'शुरू से ही प्राइवेट',
  'site.about.private.body':
    'मैसेज, फ़ोटो, फ़ाइलें, लिस्ट और डॉक्यूमेंट आपके डिवाइस पर ही एन्क्रिप्ट होते हैं; हमारा सर्वर इन्हें रखता है, पर पढ़ नहीं सकता। हम क्या देख सकते हैं, यह भी हमने {home} और {privacy} में साफ़-साफ़ लिखा है।',
  'site.about.private.homeLink': 'होम पेज',
  'site.about.noAds.title': 'न विज्ञापन, न ट्रैकिंग',
  'site.about.noAds.body':
    'Twinden का ख़र्च आपके ध्यान या डेटा से नहीं चलता। न विज्ञापन हैं, न एनालिटिक्स ट्रैकर, और कुछ भी बेचा नहीं जाता।',
  'site.about.open.title': 'खुला हिसाब',
  'site.about.open.body':
    'यह मुफ़्त है, बिना किसी लिमिट के। जिन परिवारों को यह काम का लगता है, वे योगदान देते हैं, और Twinden का ख़र्च और अब तक मिला पैसा {link}।',
  'site.about.open.link': 'हर महीने सबके सामने रखा जाता है',
  'site.about.families.title': 'परिवार सबसे पहले',
  'site.about.families.body':
    'Twinden में सिर्फ़ न्योते से आते हैं, और यह परिवारों के लिए ही बना है: हर परिवार की अपनी जगह, जहाँ सब साथ हों और अंदर छोटी चैट भी हों। यह सोशल नेटवर्क बनने की कोशिश नहीं कर रहा।',
  'site.about.why.title': 'हमने इसे क्यों बनाया',
  'site.about.why.body':
    'आज परिवार अलग-अलग शहरों और देशों में बसे हैं: दादा-दादी एक जगह, बच्चे दूसरी जगह, कज़िन विदेश में। हम चाहते थे एक ऐसी प्राइवेट जगह, जहाँ सब पास रह सकें, बिना विज्ञापन, बिना ट्रैकिंग, और बिना किसी और के पढ़े।',
  'site.about.who.title': 'हम कौन हैं',
  'site.about.who.company':
    'Twinden को {company} बनाती और चलाती है, जो छोटे और मझोले कारोबारों के लिए एक सॉफ़्टवेयर कंसल्टेंसी है। Paperdrop कंपनियों को काग़ज़, फ़ॉर्म और बार-बार हाथ से डेटा भरने से छुटकारा दिलाती है: पूरे काम का नक़्शा बनाकर, जिस काम में इंसान की ज़रूरत नहीं उसे ऑटोमेट करके, और हर कदम का ऑडिट ट्रेल रखकर। Twinden उसका अपना एक प्रोजेक्ट है।',
  'site.about.who.visit': '{site} पर जाएँ',
  'site.about.licenses': 'ओपन-सोर्स सूचनाएँ',
  'site.about.contact.title': 'हमसे बात करें',
  'site.about.contact.body':
    'सवाल, सुझाव या कोई दिक़्क़त हो, तो {email} पर लिखें। अपने परिवार के लिए Twinden चाहिए? न्योता माँगिए।',

  'site.requestInvite.title': 'न्योता माँगें',
  'site.requestInvite.intro':
    'अभी Twinden में सिर्फ़ न्योते से आते हैं। अपना नाम और ईमेल छोड़ दीजिए, हम आपसे संपर्क करेंगे। अगर आपके परिवार में कोई पहले से Twinden इस्तेमाल करता है, तो उनसे कहिए कि आपको जोड़ दें: वो ज़्यादा जल्दी होगा।',
  'site.requestInvite.thanks': 'शुक्रिया, हमें मिल गया',
  'site.requestInvite.sent': 'हम आपको {email} पर लिखेंगे। तब तक, {link}।',
  'site.requestInvite.moreLink': 'Twinden के बारे में और जानिए',
  'site.requestInvite.name': 'आपका नाम',
  'site.requestInvite.email': 'ईमेल',
  'site.requestInvite.emailHint':
    'सिर्फ़ आपको जवाब देने के लिए। जवाब देने के 90 दिन बाद हम रिक्वेस्ट मिटा देते हैं।',
  'site.requestInvite.size': 'लगभग कितने लोग?',
  'site.requestInvite.size2to5': '2–5 लोग',
  'site.requestInvite.size6to10': '6–10 लोग',
  'site.requestInvite.size11to20': '11–20 लोग',
  'site.requestInvite.size20plus': '20 से ज़्यादा',
  'site.requestInvite.sending': 'भेज रहे हैं…',
  'site.requestInvite.privacy':
    'आपकी भेजी जानकारी हम कैसे संभालते हैं, यह {link} में लिखा है।',

  // Run by families and Shape Twinden (M55, docs/run-by-families.md)
  'site.nav.ideas': 'Twinden को सँवारें',
  'site.runBy.title': 'इसे चलाते हैं वही परिवार जो इसे इस्तेमाल करते हैं।',
  'site.runBy.label': 'इस महीने का ख़र्च और योगदान',
  'site.runBy.costs': 'ख़र्च {amount}',
  'site.runBy.received': 'योगदान {amount}',
  'site.runBy.familiesOne': '{count} परिवार ने योगदान दिया',
  'site.runBy.familiesOther': '{count} परिवारों ने योगदान दिया',
  'site.runBy.short': 'इस महीने {amount} कम',
  'site.runBy.link': 'पूरा ख़र्च देखें',
  'site.costs.fromFamiliesOne': '{count} परिवार से',
  'site.costs.fromFamiliesOther': '{count} परिवारों से',
  'site.ideas.title': 'Twinden को सँवारें',
  'site.ideas.intro':
    'Twinden इस्तेमाल करने वाले परिवारों के सुझाव। जो आप चाहते हैं उन्हें वोट दें: सबसे ज़्यादा चाहे गए पहले बनते हैं।',
  'site.ideas.signInLine': 'सुझाव देने या वोट करने के लिए {link}।',
  'site.ideas.post': 'सुझाव दें',
  'site.ideas.empty': 'अभी कोई सुझाव नहीं। पहला सुझाव आप दें।',
  'site.ideas.emptySignedOut': 'अभी कोई सुझाव नहीं।',
  'site.ideas.from': 'एक Twinden परिवार से · {date}',
  'site.ideas.status.planned': 'योजना में',
  'site.ideas.status.building': 'बन रहा है',
  'site.ideas.status.done': 'हो गया',
  'site.ideas.status.notNow': 'अभी नहीं',
  'site.ideas.shipped': '{month} में आया',
  'site.ideas.mergedOne': '{count} सुझाव इसमें जोड़ा गया',
  'site.ideas.mergedOther': '{count} सुझाव इसमें जोड़े गए',
  'site.ideas.showDone': 'हो चुके {count} दिखाएँ',
  'site.ideas.hideDone': 'हो चुके छिपाएँ',
  'site.ideas.showNotNow': '"अभी नहीं" वाले {count} दिखाएँ',
  'site.ideas.hideNotNow': '"अभी नहीं" वाले छिपाएँ',
  'site.ideas.vote': '“{title}” को वोट दें',
  'site.ideas.unvote': '“{title}” से अपना वोट वापस लें',
  'site.ideas.votesOne': '{count} वोट',
  'site.ideas.votesOther': '{count} वोट',
  'site.ideas.edit': 'बदलें',
  'site.ideas.truncated': 'सबसे ज़्यादा चाहे गए {count} सुझाव दिख रहे हैं',
  'site.ideas.loadError': 'सुझाव लोड नहीं हो पाए।',
  'site.ideas.voteFailed': 'आपका वोट सहेजा नहीं जा सका',
  'site.ideas.posted': 'धन्यवाद! आपका सुझाव लग गया।',
  'site.ideas.saved': 'आपका सुझाव सहेज लिया गया',
  'site.ideas.sheet.title': 'सुझाव दें',
  'site.ideas.sheet.editTitle': 'अपना सुझाव बदलें',
  'site.ideas.sheet.titleLabel': 'शीर्षक',
  'site.ideas.sheet.titlePlaceholder': 'Twinden को क्या बेहतर बनाएगा?',
  'site.ideas.sheet.bodyLabel': 'विवरण (चाहें तो)',
  'site.ideas.sheet.bodyPlaceholder':
    'यह किस काम आएगा, और परिवार में कौन इसे इस्तेमाल करेगा',
  'site.ideas.sheet.anonymous':
    'यह "एक Twinden परिवार से" दिखेगा: आपका या आपके परिवार का नाम कभी नहीं। 15 मिनट तक आप इसे बदल सकते हैं।',
  'site.ideas.sheet.titleNeeded': 'अपने सुझाव को शीर्षक दें',
  'site.ideas.sheet.tooLong': '{count} अक्षर ज़्यादा',
  'site.ideas.sheet.post': 'भेजें',
  'site.ideas.sheet.save': 'सहेजें',
};
